import React from 'react'

export const IcoArrowDown = ({...props}) => {
  return <svg className='icon-arrow-down' viewBox="0 0 12 7" {...props}>
    <path d="M10.291 2.09274C10.9214 1.46291 10.4754 0.385315 9.58425 0.385315H2.41268C1.52199 0.385315 1.07572 1.46201 1.70525 2.0921L5.28781 5.67789C5.67815 6.06859 6.31132 6.06887 6.70202 5.67853L10.291 2.09274Z" />
  </svg>
}
